import React, { useState, useEffect } from "react";
import "./NumericInput.css"; // Подключаем стили

const NumericInput = ({ value, step = 1, min = 0, max = 9999, isPrice = false, onChange }) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleChange = (e) => {
    let newValue = e.target.value;
    if (/^\d*\.?\d*$/.test(newValue)) {
      setInputValue(newValue);
    }
  };

  const handleBlur = () => {
    let finalValue = parseFloat(inputValue);
    if (isNaN(finalValue) || finalValue < min) finalValue = min;
    if (finalValue > max) finalValue = max;
    setInputValue(isPrice ? finalValue.toFixed(2) : finalValue);
    onChange(finalValue);
  };

  const increaseValue = () => {
    let currentValue = parseFloat(inputValue) || 0;
    let newValue = Math.min(currentValue + (isPrice ? 10.00 : 1), max);
    setInputValue(isPrice ? newValue.toFixed(2) : newValue);
    onChange(newValue);
  };

  const decreaseValue = () => {
    let currentValue = parseFloat(inputValue) || 0;
    let newValue = Math.max(currentValue - (isPrice ? 10.00 : 1), min);
    setInputValue(isPrice ? newValue.toFixed(2) : newValue);
    onChange(newValue);
  };

  const handleWheel = (e) => {
    e.preventDefault();
    if (e.deltaY < 0) increaseValue(); // Прокрутка вверх - увеличиваем
    else decreaseValue(); // Прокрутка вниз - уменьшаем
  };

  return (
    <div className="numeric-input-container" onWheel={handleWheel}>
      <button className="numeric-btn decrement" onClick={decreaseValue}>−</button>
      <input
        type="text"
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        className="numeric-input"
      />
      <button className="numeric-btn increment" onClick={increaseValue}>+</button>
    </div>
  );
};

export default NumericInput;
